var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navigation'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('v-footer',{attrs:{"app":""}},[_c('v-col',{staticClass:"text-center caption pa-0 font-weight-thin",attrs:{"cols":"12","padless":""}},[_vm._v("Copyright © 2016-"+_vm._s(new Date().getFullYear())+" FinCom.co All rights reserved. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }